// extracted by mini-css-extract-plugin
module.exports = {"container":"VerticalLines_container__2MyHW","item":"VerticalLines_item__tjsqn"};